import SearchBar from '@/components/company/filters/SearchBar';
import FilterSelect from '@/components/company/filters/FilterSelect';
import ClearFilterButton from '@/components/company/filters/ClearFilterButton';

interface JobDescriptionFiltersProps {
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  selectedRole: string;
  setSelectedRole: (value: string) => void;
  selectedStatus: string;
  setSelectedStatus: (value: string) => void;
  selectedKeyActivity: string;
  setSelectedKeyActivity: (value: string) => void;
  roleOptions: { label: string; value: string }[];
  keyActivityOptions: { label: string; value: string }[];
}

export default function JobDescriptionFilters({
  searchTerm,
  setSearchTerm,
  selectedRole,
  setSelectedRole,
  selectedStatus,
  setSelectedStatus,
  selectedKeyActivity,
  setSelectedKeyActivity,
  roleOptions,
  keyActivityOptions,
}: JobDescriptionFiltersProps) {
  return (
    <div className="flex justify-start mt-5 px-5 gap-2">
      <SearchBar value={searchTerm} onChange={setSearchTerm} placeholder="Search job description..." className="w-72" />
      <FilterSelect label="Role" options={roleOptions} value={selectedRole} onChange={setSelectedRole} />
      <FilterSelect
        label="Key Activity"
        options={keyActivityOptions}
        value={selectedKeyActivity}
        onChange={setSelectedKeyActivity}
      />
      <FilterSelect
        label="Status"
        options={[
          { label: 'Published', value: 'Published' },
          { label: 'Unpublished', value: 'Unpublished' },
        ]}
        value={selectedStatus}
        onChange={setSelectedStatus}
      />
      <ClearFilterButton
        onClear={() => {
          setSearchTerm('');
          setSelectedRole('');
          setSelectedStatus('');
          setSelectedKeyActivity('');
        }}
      />
    </div>
  );
}
